import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
  uuidv4,
} from "@/plugins/helpers";

import { database } from "@/plugins/firebase";

function getUser() {
  var userStr = getLocalStorage(process.env.VUE_APP_USER_OBJECT);
  if (!userStr) {
    var defaultUser = {
      userID: uuidv4(),
      bubbles: {},
    };
    setLocalStorage(
      process.env.VUE_APP_USER_OBJECT,
      JSON.stringify(defaultUser)
    );
    database.ref(`users/${defaultUser.userID}`).set(defaultUser);
    return defaultUser;
  }
  return JSON.parse(userStr);
}

const state = {
  user: getUser(),
};

const getters = {
  getUser(state) {
    return state.user;
  },
};

const mutations = {
  SET_USER(state, payload) {
    state.user = payload;
    setLocalStorage(process.env.VUE_APP_USER_OBJECT, JSON.stringify(payload));
  },
  SET_NAME(state, payload) {
    state.user.fullName = payload;
    setLocalStorage(process.env.VUE_APP_USER_OBJECT, JSON.stringify(state.user));
    database.ref(`users/${state.user.userID}`).set(state.user);
  },
  LOGOUT(state) {
    removeLocalStorage(process.env.VUE_APP_USER_OBJECT);
    state.user = getUser();
  },
};

export default {
  namespaced: "Authen",
  state,
  mutations,
  getters,
};
